'use client';

import canvasHelper from '../../helper/canvas.js';
import '../../../_virtual/_tslib.js';
import calculation from '../../helper/calculation.js';
import animation from '../../helper/animation.js';
import { CHART_DECREASE_RATIO, CHART_LINE_WIDTH, CROSS_LINE_COLOR, CROSS_LINE_WIDTH, LIST_COLORS } from '../../helper/config.js';

function LineChart(props) {
    var control = props.control, config = props.config;
    var _a = config.chart.smooth, smooth = _a === void 0 ? true : _a;
    var _b = (config.default || {}).listColors, listColors = _b === void 0 ? LIST_COLORS : _b;
    function calculatingPoints(props) {
        var chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation;
        var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis, chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis;
        var dataBySeries = chartInformation.dataBySeries, series = chartInformation.series;
        var pointCoordinates = {};
        series.map(function (item, index) {
            var _a;
            var points = [];
            var xPoint = chartStartingPointInXAxis;
            dataBySeries[item].forEach(function (data) {
                var yPoint = calculation.getPointCoordinateInYAxis({
                    chartInformation: chartInformation,
                    chartStartingPointInYAxis: chartStartingPointInYAxis,
                    chartEndingPointInYAxis: chartEndingPointInYAxis,
                    data: data
                }, animation.easeInOutSine(control.controlRatio)).pointCoordinateInYAxis;
                points.push([xPoint, yPoint]);
                xPoint += xRange;
            });
            Object.assign(pointCoordinates, (_a = {},
                _a[item] = {
                    points: points,
                    color: listColors[index]
                },
                _a));
        });
        return pointCoordinates;
    }
    function point(dataPoints) {
        var ctx = props.ctx;
        var points = dataPoints.points, color = dataPoints.color;
        for (var i = 0; i < points.length; i++) {
            ctx.beginPath();
            ctx.arc(points[i][0], points[i][1], 3, 0, 2 * Math.PI);
            ctx.fillStyle = color.background;
            ctx.strokeStyle = color.foreground;
            ctx.lineWidth = 1;
            ctx.fill();
            ctx.stroke();
        }
    }
    function chartLine(dataPoints) {
        var ctx = props.ctx;
        var points = dataPoints.points, color = dataPoints.color;
        var listBezierPoints = canvasHelper.computePoints(points);
        ctx.beginPath();
        ctx.save();
        listBezierPoints.forEach(function (point) {
            if (point.length < 6) {
                ctx.moveTo(point[0], point[1]);
                return;
            }
            if (smooth) {
                ctx.bezierCurveTo(point[0], point[1], point[2], point[3], point[4], point[5]);
                return;
            }
            ctx.lineTo(point[4], point[5]);
        });
        /*
         * Line style configuration
         * */
        ctx.lineWidth = CHART_LINE_WIDTH;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = color.foreground;
        ctx.stroke();
        ctx.restore();
        ctx.closePath();
    }
    function drawVerticalLine(dataPoints) {
        var ctx = props.ctx, chartInformation = props.chartInformation, chartNecessaryInformation = props.chartNecessaryInformation, mouse = props.mouse;
        var chartArea = chartNecessaryInformation.chartArea, xRange = chartNecessaryInformation.xRange;
        var chartStartingPointInYAxis = chartArea.chartStartingPointInYAxis, chartEndingPointInYAxis = chartArea.chartEndingPointInYAxis, chartStartingPointInXAxis = chartArea.chartStartingPointInXAxis;
        var xAxis = chartInformation.xAxis, series = chartInformation.series;
        /* Do nothing when mouse is null */
        if (!mouse)
            return;
        var startingPoint = chartStartingPointInXAxis;
        xAxis.forEach(function (_, index) {
            var pointTo = xRange;
            if (index === 0 || index === xAxis.length - 1) {
                pointTo = xRange / 2;
            }
            /*
             * Collision detection
             * */
            if (mouse.x >= startingPoint &&
                mouse.x <= startingPoint + pointTo &&
                mouse.y >= chartEndingPointInYAxis &&
                mouse.y <= chartStartingPointInYAxis) {
                /*
                 * Draw points and vertical line
                 * */
                series.map(function (item) {
                    var _a = dataPoints[item], points = _a.points, color = _a.color;
                    var x = points[index][0];
                    var y = points[index][1];
                    ctx.beginPath();
                    ctx.save();
                    ctx.moveTo(x, chartEndingPointInYAxis);
                    ctx.lineTo(x, chartStartingPointInYAxis);
                    ctx.setLineDash([5, 3]);
                    ctx.strokeStyle = CROSS_LINE_COLOR;
                    ctx.lineWidth = CROSS_LINE_WIDTH;
                    ctx.stroke();
                    ctx.restore();
                    ctx.closePath();
                    ctx.beginPath();
                    ctx.arc(x || 0, y || 0, 4, 0, 2 * Math.PI);
                    ctx.lineWidth = 2;
                    ctx.fillStyle = color.background;
                    ctx.strokeStyle = color.foreground;
                    ctx.fill();
                    ctx.stroke();
                    ctx.closePath();
                });
            }
            startingPoint += pointTo;
        });
    }
    function draw() {
        var chartInformation = props.chartInformation;
        var series = chartInformation.series;
        var dataPoints = calculatingPoints(props);
        series.forEach(function (item) {
            chartLine(dataPoints[item]);
            point(dataPoints[item]);
        });
        drawVerticalLine(dataPoints);
        control.controlRatio += CHART_DECREASE_RATIO;
        if (control.controlRatio >= 1) {
            control.controlRatio = 1;
        }
    }
    return {
        draw: draw
    };
}

export { LineChart as default };
//# sourceMappingURL=line.js.map
